import { Suspense, useCallback } from 'react';

import { useCosmosController } from 'core/controllers/CosmosScreenController';
import { ONBOARDING_FLOW_SCREENS } from 'core/constants';
import OnbLoader from 'src/components/OnbLoader';

import {
  AutoFetchPanScreen,
  UserPanInputScreen,
  UserNameAutoFetchScreen,
  UserNameInputScreen,
  UserNameMismatchScreen,
  PanNumberConfirmationScreen,
  DOBScreen,
  AutoFetchBank,
  BankRPDScreen,
  BankPDScreen,
  KycDeclaration,
  SelectOccupationScreen,
  GenderSelectionScreen,
  FathersNameScreen,
  IncomeRangeScreen,
  MaritalStatusScreen,
  TradingExperienceScreen,
  SelfieScreen,
  SignatureUpload,
  Digilocker,
  DocumentUploadScreen,
  ManualDocUpload,
  AddressTextScreen,
  EmailUpdate,
  MobileUpdate,
  EkycVerification,
  LocationFetchScreen,
  AOFEsign,
  IncomeProofScreen,
  CoparcenerDetailScreen,
  PendingScreen,
  FnoConfirmationScreen,
  ErrorScreen,
  SuccessScreen,
  NomineeInfo,
  NomineeOtpVerificationScreen,
} from 'src/screens';

const CosmosScreens = () => {

  const { activeScreen, isOnbDataLoading } = useCosmosController();
  const renderScreen = useCallback((screenType: string) => {
    switch (screenType) {
      case ONBOARDING_FLOW_SCREENS.PAN_AUTO_FETCH_SCREEN:
        return <AutoFetchPanScreen />;
      case ONBOARDING_FLOW_SCREENS.PAN_INPUT_SCREEN:
        return <UserPanInputScreen />;
      case ONBOARDING_FLOW_SCREENS.NAME_AUTO_FETCH_SCREEN:
        return <UserNameAutoFetchScreen />;
      case ONBOARDING_FLOW_SCREENS.NAME_INPUT_SCREEN:
        return <UserNameInputScreen />;
      case ONBOARDING_FLOW_SCREENS.NAME_MISMATCH_SCREEN:
        return <UserNameMismatchScreen />;
      case ONBOARDING_FLOW_SCREENS.PAN_NO_CONFIRMATION:
        return <PanNumberConfirmationScreen />;
      case ONBOARDING_FLOW_SCREENS.DOB_SCREEN:
        return <DOBScreen />;
      case ONBOARDING_FLOW_SCREENS.AUTO_FETCH_BANK:
        return <AutoFetchBank />;
      case ONBOARDING_FLOW_SCREENS.BANK_RPD_SCREEN:
        return <BankRPDScreen />;
      case ONBOARDING_FLOW_SCREENS.BANK_PD_SCREEN:
        return <BankPDScreen />;
      case ONBOARDING_FLOW_SCREENS.KYC_DECLARATION:
        return <KycDeclaration />
      case ONBOARDING_FLOW_SCREENS.OCCUPATION_SCREEN:
        return <SelectOccupationScreen />;
      case ONBOARDING_FLOW_SCREENS.GENDER_SELECTION_SCREEN:
        return <GenderSelectionScreen />;
      case ONBOARDING_FLOW_SCREENS.FATHERS_NAME_SCREEN:
        return <FathersNameScreen />;
      case ONBOARDING_FLOW_SCREENS.INCOME_RANGE:
        return <IncomeRangeScreen />;
      case ONBOARDING_FLOW_SCREENS.MARITAL_STATUS:
        return <MaritalStatusScreen />;
      case ONBOARDING_FLOW_SCREENS.TRADING_EXPERIENCE_SCREEN:
        return <TradingExperienceScreen />;
      case ONBOARDING_FLOW_SCREENS.SELFIE:
        return <SelfieScreen />;
      case ONBOARDING_FLOW_SCREENS.SIGNATURE:
        return <SignatureUpload />;
      case ONBOARDING_FLOW_SCREENS.DIGILOCKER:
        return <Digilocker />;
      case ONBOARDING_FLOW_SCREENS.PROOF_OF_IDENTITY:
        return <DocumentUploadScreen />;
      case ONBOARDING_FLOW_SCREENS.MANUAL_DOC_UPLOAD:
        return <ManualDocUpload />;
      case ONBOARDING_FLOW_SCREENS.ADDRESS_TEXT:
        return <AddressTextScreen />;

      case ONBOARDING_FLOW_SCREENS.EMAIL_INPUT:
        return <EmailUpdate />;

      case ONBOARDING_FLOW_SCREENS.MOBILE_INPUT:
        return <MobileUpdate />;
        

      case ONBOARDING_FLOW_SCREENS.NOMINEE_EDIT_OTP:
        return <NomineeOtpVerificationScreen />;

      // case ONBOARDING_FLOW_SCREENS.IPV:
      //   return <IPV />;

      case ONBOARDING_FLOW_SCREENS.NOMINEE_ADDITION:
        return <NomineeInfo />;

      case ONBOARDING_FLOW_SCREENS.EKYC_VERIFICATION_SCREEN:
        return <EkycVerification />;
      case ONBOARDING_FLOW_SCREENS.LOCATION_VALIDATION:
        return <LocationFetchScreen />;

      case ONBOARDING_FLOW_SCREENS.ESIGN:
        return <AOFEsign />;

      case ONBOARDING_FLOW_SCREENS.INCOME_PROOF:
        return <IncomeProofScreen />;

      case ONBOARDING_FLOW_SCREENS.COPARCENER_DETAIL_SCREEN:
        return <CoparcenerDetailScreen />;

      case ONBOARDING_FLOW_SCREENS.ONBOARDING_PENDING_SCREEN:
        return <PendingScreen />

      case ONBOARDING_FLOW_SCREENS.FNO_CONFIRMATION_SCREEN:
        return <FnoConfirmationScreen />;

      case ONBOARDING_FLOW_SCREENS.FAILURE:
        return <ErrorScreen />;

      case ONBOARDING_FLOW_SCREENS.SUCCESS_SCREEN:
        return <SuccessScreen />;

      default:
        return null;
    }
  }, []);

  if (!activeScreen || isOnbDataLoading)
    return (
      <div className='absolute-center h-full'><OnbLoader /></div>
    );

  return activeScreen ? (
    <Suspense fallback={<div className='absolute-center h-full'><OnbLoader /></div>}>
      {renderScreen(activeScreen)}
    </Suspense>
  ) : null;
};

export default CosmosScreens;
